(function () {
  var current = 0;
  var slides = [];
  var isAnimating = false;
  var DURATION = 900;

  function init() {
    // Le système "diapositives plein écran" est une expérience volontaire de
    // la home uniquement — appliqué à toutes les pages, il bloquait le
    // scroll (overflow caché) sur les pages produit/contenu, rendant le
    // texte au-delà d'un écran invisible (bug du 2026-07-22). Les autres
    // pages doivent scroller normalement, comme n'importe quel site.
    if (!document.body.classList.contains('template-index')) {
      return;
    }

    if (window.Shopify && window.Shopify.designMode) {
      // Dans l'éditeur de thème, il n'y a pas de vrai scroll pour déclencher
      // les slides/le reveal : sans cette sortie, les sections restent
      // invisibles (opacity:0) et superposées en position:fixed, rendant
      // l'édition impossible (cf. bug du 2026-07-15).
      var revealAll = function () {
        document.querySelectorAll('.tbc-develop').forEach(function (el) {
          el.classList.add('in');
        });
      };
      revealAll();
      // L'éditeur recharge une section via AJAX à chaque modif de réglage
      // (nouveau DOM = .tbc-develop repart à opacity:0) : on ré-applique.
      document.addEventListener('shopify:section:load', revealAll);
      return;
    }

    slides = Array.from(document.querySelectorAll(
      '#MainContent .shopify-section, .shopify-section-group-footer-group'
    ));
    if (!slides.length) return;

    slides.forEach(function (s, i) {
      s.classList.add('tbc-page-slide');
      if (i === 0) {
        s.classList.add('state-active');
        triggerDevelop(s);
      } else {
        s.classList.add('state-below');
      }
    });

    window.addEventListener('wheel', onWheel, { passive: false });

    var touchStartY = 0;
    window.addEventListener('touchstart', function (e) {
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    window.addEventListener('touchend', function (e) {
      var dy = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(dy) <= 40) return;
      var dir = dy > 0 ? 1 : -1;
      // Si la diapositive active a encore du contenu à faire défiler dans
      // le sens du geste (ex: featured_product plus haut qu'un écran), on
      // laisse le scroll tactile natif faire son travail au lieu de sauter
      // direct à la diapositive suivante (bug du 2026-07-22 : le sélecteur
      // de quantité et les boutons panier restaient inatteignables sur
      // mobile car chaque swipe changeait de diapositive avant d'avoir pu
      // scroller jusqu'en bas).
      if (!isAtScrollBoundary(slides[current], dir)) return;
      navigate(dir);
    }, { passive: true });

    window.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'PageDown') navigate(1);
      if (e.key === 'ArrowUp'   || e.key === 'PageUp')   navigate(-1);
    });
  }

  function isScrollableSlide(slide) {
    return !!slide && slide.scrollHeight > slide.clientHeight + 1;
  }

  // dir > 0 (on avance) : vrai seulement si on a déjà atteint le bas du
  // scroll interne. dir < 0 (on recule) : vrai seulement si on est déjà en
  // haut. Une diapositive sans scroll interne (contenu tenant sur un écran)
  // est toujours considérée "à la limite" — comportement inchangé pour elle.
  function isAtScrollBoundary(slide, dir) {
    if (!isScrollableSlide(slide)) return true;
    if (dir > 0) return slide.scrollTop + slide.clientHeight >= slide.scrollHeight - 1;
    return slide.scrollTop <= 1;
  }

  function onWheel(e) {
    var dir = e.deltaY > 0 ? 1 : -1;
    if (!isAtScrollBoundary(slides[current], dir)) return;
    e.preventDefault();
    if (isAnimating) return;
    navigate(dir);
  }

  function navigate(dir) {
    var next = current + dir;
    if (next < 0 || next >= slides.length || isAnimating) return;
    isAnimating = true;

    var prev = current;
    current = next;

    var entering = slides[current];
    var leaving  = slides[prev];

    // Positionne le slide entrant sans transition
    entering.style.transition = 'none';
    entering.classList.remove('state-active', 'state-above', 'state-below');
    entering.classList.add(dir > 0 ? 'state-below' : 'state-above');
    entering.offsetHeight; // reflow

    // Lance les transitions
    entering.style.transition = '';
    entering.classList.remove('state-below', 'state-above');
    entering.classList.add('state-active');

    leaving.classList.remove('state-active');
    leaving.classList.add(dir > 0 ? 'state-above' : 'state-below');

    triggerDevelop(entering);

    setTimeout(function () { isAnimating = false; }, DURATION);
  }

  function triggerDevelop(slide) {
    slide.querySelectorAll('.tbc-develop').forEach(function (el) {
      el.classList.add('in');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
